<dx-popup
    title="Confirm Payment"
    [(visible)]="visible"
    width="500px"
    height="250px"
    [showCloseButton]="false"
    (onShown)="onShown()"
>
    <div *dxTemplate="let t = data; of: 'content'">
        <div>Confirm payment of {{ finalPaymentAmount | currency: 'USD':'symbol' }}</div>
        <dx-toolbar style="margin-top: 20px">
            <dxi-item location="before">
                <dx-button
                    #submitButton
                    [tabindex]="1"
                    text="Ok"
                    (onClick)="onSubmit($event)"
                    icon="../../../assets/images/credit_card_16x16.png"
                ></dx-button>
            </dxi-item>
            <dxi-item location="before">
                <dx-button
                    text="Cancel"
                    (onClick)="onCancel($event)"
                    icon="{{ env.assetsPath }}images/Cancel_16x16.png"
                ></dx-button>
            </dxi-item>
        </dx-toolbar>
    </div>
</dx-popup>
